import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { CloudUploadOutlined } from '@mui/icons-material';
import SectionHeader from '../SectionHeader';
import UploadField from '../UploadField';

const DocumentsSection = ({ form, handleFileChange }) => {
    return (
        <>
            <SectionHeader icon={CloudUploadOutlined} title="Documents" subtitle="Upload photograph and proof of address" />
            <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} sm={6}>
                    <UploadField
                        label="Profile Photograph"
                        preview={form.photographPreview}
                        fileName={form.photographName}
                        onChange={handleFileChange('photograph', 'photographPreview', 'photographName')}
                        required
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <UploadField
                        label="Proof of Address (Aadhaar/Voter ID)"
                        preview={form.poaImagePreview}
                        fileName={form.poaImageName}
                        onChange={handleFileChange('poaImage', 'poaImagePreview', 'poaImageName')}
                        required
                    />
                </Grid>
            </Grid>
        </>
    );
};

DocumentsSection.propTypes = {
    form: PropTypes.object.isRequired,
    handleFileChange: PropTypes.func.isRequired
};

export default DocumentsSection;
